import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRomance = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.0183 25C14.2034 27.3912 16.0001 29 16.0001 29C16.0001 29 17.7967 27.3912 18.9818 25M6.51871 18C3.73516 14.9398 4.00728 10.0073 4.00728 10.0073C4.00728 10.0073 8.93976 9.73516 12 12.5187M25.4813 18C28.2648 14.9398 27.9927 10.0073 27.9927 10.0073C27.9927 10.0073 23.0602 9.73516 20 12.5187M16 22C16 22 20 18.4183 20 14C20 9.58172 16 6 16 6C16 6 12 9.58172 12 14C12 18.4183 16 22 16 22ZM16 22C16 22 12.6421 18 8.5 18C4.35786 18 1 22 1 22C1 22 4.35786 26 8.5 26C12.6421 26 16 22 16 22ZM16 22C16 22 19.3579 26 23.5 26C27.6421 26 31 22 31 22C31 22 27.6421 18 23.5 18C19.3579 18 16 22 16 22ZM11 5H11.05M21 5H21.05M16 2H16.05",
		stroke: "#DFCBF5",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgRomance;
